<template>
  <h2 class="h3 mb-3">
    <span class="text-primary border-bottom border-primary border-2 pb-1">
      男鞋尺碼參考
    </span>
  </h2>
  <div class="table-responsive">
    <table class="table align-middle">
      <thead>
        <tr>
          <th>腳長 (cm)</th>
          <td>24</td>
          <td>24.5</td>
          <td>25</td>
          <td>25.5</td>
          <td>26</td>
          <td>26.5</td>
          <td>27</td>
          <td>27.5</td>
          <td>28</td>
          <td>29</td>
          <td>30</td>
          <td class="rounded">30.5</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>歐碼</th>
          <td>38.5</td>
          <td>39</td>
          <td>40</td>
          <td>40.5</td>
          <td>41</td>
          <td>42</td>
          <td>42.5</td>
          <td>43</td>
          <td>44</td>
          <td>44.5</td>
          <td>46</td>
          <td>47</td>
        </tr>
        <tr>
          <th>英國碼 uk</th>
          <td>5</td>
          <td>5.5</td>
          <td>6</td>
          <td>6.5</td>
          <td>7</td>
          <td>7.5</td>
          <td>8</td>
          <td>8.5</td>
          <td>9</td>
          <td>9.5</td>
          <td>11</td>
          <td>11.5</td>
        </tr>
        <tr>
          <th>美國碼 us</th>
          <td>6</td>
          <td>6.5</td>
          <td>7</td>
          <td>7.5</td>
          <td>8</td>
          <td>8.5</td>
          <td>9</td>
          <td>9.5</td>
          <td>10</td>
          <td>10.5</td>
          <td>12</td>
          <td>12.5</td>
        </tr>
      </tbody>
    </table>
  </div>
  <h2 class="h3 mb-3">
    <span class="text-primary border-bottom border-primary border-2 pb-1">
      女鞋尺碼參考
    </span>
  </h2>
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>腳長 (cm)</th>
          <td>21.5</td>
          <td>22</td>
          <td>22.5</td>
          <td>23</td>
          <td>23.5</td>
          <td>24</td>
          <td>24.5</td>
          <td>25</td>
          <td>25.5</td>
          <td>26</td>
          <td>26.5</td>
          <td>27</td>
          <td>27.5</td>
          <td>28</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th>歐碼</th>
          <td>34</td>
          <td>35</td>
          <td>36</td>
          <td>37</td>
          <td>37.5</td>
          <td>38</td>
          <td>38.5</td>
          <td>39</td>
          <td>40</td>
          <td>40.5</td>
          <td>41</td>
          <td>42</td>
          <td>42.5</td>
          <td>43</td>
        </tr>
        <tr>
          <th>英國碼 uk</th>
          <td>1.5</td>
          <td>2</td>
          <td>3</td>
          <td>3.5</td>
          <td>4</td>
          <td>4.5</td>
          <td>5</td>
          <td>5.5</td>
          <td>6</td>
          <td>6.5</td>
          <td>7</td>
          <td>7.5</td>
          <td>8</td>
          <td>8.5</td>
        </tr>
        <tr>
          <th>美國碼 us</th>
          <td>4</td>
          <td>4.5</td>
          <td>5.5</td>
          <td>6</td>
          <td>6.5</td>
          <td>7</td>
          <td>7.5</td>
          <td>8</td>
          <td>8.5</td>
          <td>9</td>
          <td>9.5</td>
          <td>10</td>
          <td>10.5</td>
          <td>11</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
